import { DeliveryZone, Store as StoreModel } from '@core/models';
import { PointInShapePredicate } from '../interfaces';

/**
 * Evaluates whether a store covers the user location in its delivery zones.
 */
export function evaluateStoreDeliveryAvailability(
	store: StoreModel,
	userLocation: { lat: number; lng: number },
	isPointInShape?: PointInShapePredicate
): { isAvailable: boolean; matchedZones: DeliveryZone[] } {
	if (!userLocation.lat && !userLocation.lng) {
		return { isAvailable: false, matchedZones: [] };
	}

	if (!store.delivery_zone || store.delivery_zone.length === 0 || !isPointInShape) {
		return { isAvailable: false, matchedZones: [] };
	}

	const matchedZones: DeliveryZone[] = [];
	for (const deliveryZone of store.delivery_zone) {
		if (isPointInShape(userLocation, deliveryZone, store.location)) {
			matchedZones.push(deliveryZone);
		}
	}

	return {
		isAvailable: matchedZones.length > 0,
		matchedZones,
	};
}

/**
 * Checks if delivery service is available given the current list of delivery zones and selected store.
 */
export function isDeliveryAddressAvailable(
	deliveryZones: DeliveryZone[] | null | undefined,
	currentStore?: StoreModel | null
): boolean {
	if (!deliveryZones || deliveryZones.length === 0) {
		return false;
	}

	if (currentStore?.idLocal != null) {
		return deliveryZones.some(zone => zone.localId === currentStore.idLocal);
	}

	return deliveryZones.length > 0;
}
